import { AlertTriangle } from 'lucide-react';

interface Props {
  familyName?: string | null;
}

// Shown on the parent-portal pages when an admin opens them for a specific
// family. Everything under it is read-only (Principle 9: privileged users see
// what a parent actually sees).
export function ViewAsFamilyBanner({ familyName }: Props) {
  return (
    <div role="status" className="flex items-start gap-3 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <p>
        You are viewing {familyName ? <strong>{familyName}</strong> : 'this family'} as an administrator. This is what their guardians see; it is read-only.
      </p>
    </div>
  );
}
